import { Box } from "@mui/material";
import styled from "styled-components";

export const Title = styled("h1")`
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 1.5rem;
`;

export const Result = styled("div")`
  font-size: 1.25rem;
  font-weight: 600;
  margin-top: 1rem;
`;

export const StyledBox = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 3rem;
`;
